export default "__VITE_PUBLIC_ASSET__9eab0d74__"